//スライドショウ オブジェクト作成
gVar.slid = new sd_slideshow(7500);

jQuery(function() {

/**
 * スライド実行
 */
jQuery(window).on('load',function(){

	//スライドショウ実行
	gVar.slid.slideshow();

	//スライド高さセット実行
 	gVar.slid.heightSet();

 });

/**
 * スライドショウ高さ再セット実行
 */
jQuery(window).on('resize',function(){

	//timerID;
	var timer = false;

	if (timer !== false) {
		clearTimeout(timer);
	}

	timer = setTimeout(function() {
	 	gVar.slid.heightSet();
	}, 1000);

 });




/**
 * フルスクリーンナビゲーション
 */
(function(){

	var $navBtn  = jQuery('.header-nav_btn .btn');
	var $nav     = jQuery('#header-nav');
	var $navBody = jQuery('.header-nav_body');
	
	//ナビゲーションをフェードイン/アウト、ウィンドウのスクロール停止/再開。
	$navBtn.on('click',function(){
		if($nav.hasClass('js-fade-in')){
			jQuery($nav).addClass('js-fade-out').removeClass('js-fade-in');
			return_scroll();
			$navBtn.text('menu');
			setTimeout(function(){
				jQuery($navBody).removeClass('nav-on');
			},100);
			// setTimeout(function(){
			// 	jQuery('body').addClass('js-body-out');
			// },500);
			// setTimeout(function(){
			// 	jQuery('body').removeClass('js-body-out js-body');
			// },1000);
		}else{
//			jQuery('body').addClass('js-body');
			setTimeout(function(){
				jQuery($nav).addClass('js-fade-in').removeClass('js-fade-out');
				jQuery($navBody).addClass('nav-on');
				no_scroll();
				$navBtn.text('close');				
			},100);
		}
	});

	//ウィンドウをリサイズすると、ナビゲーションとスクロールを初期設定に戻す。
	jQuery(window).on('resize',function(){
		$navBtn.text('menu');
		return_scroll();
		$nav.removeClass();
		$navBody.removeClass('nav-on');
		jQuery('body').removeClass('js-body-out js-body');
	});

}());



/**
 * 可視領域に要素が出現した時にanimate.cssのclassを付与し、スクロールに対するインタラクションを実行させる。
 */
jQuery(window).on('touchstart scroll', function(){
	animateScroll();
	fadeIn('.go-to-top');
});



/**
 * ウィンドウ上部に戻る
 */
jQuery('.go-to-top').on('click',function(){
	jQuery('body, html').animate({ scrollTop: 0 }, 800, 'swing');
	return false;
});



/**
 * ページ内スムーズスクロール実行(a要素を指定する)
 */
smoothScroll('a[href^=#]');









});//jQuery end